import type { ReactElement, ReactNode } from "react";

import { cn } from "@/lib/utils";
import { MarketingNav } from "./MarketingNav";
import { MarketingFooter } from "./MarketingFooter";

interface LayoutProps {
  children: ReactNode;
  ambient?: boolean;
}

export function MarketingLayout({
  children,
  ambient = false,
}: LayoutProps): ReactElement {
  return (
    <div
      className={cn(
        "flex min-h-screen flex-col bg-background text-foreground",
        ambient && "marketing-calm",
      )}
    >
      <MarketingNav />
      <main className="flex-1 overflow-hidden">{children}</main>
      <MarketingFooter />
    </div>
  );
}
